import TableRowAction from 'components/common/TableRowAction';
import React, { useState } from 'react';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import SelectStudentModal from '../school/SelectStudentModal';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import dayjs from 'dayjs';
import { Col, Row } from 'react-bootstrap';
import OrphanageForm from './OrphanageForm';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useOrphanage,
  useUpdateOrphanage,
  useOrphanageOrphans,
  useCreateOrphanageOrphan,
  useDeleteOrphanageOrphan
} from 'hooks/useBeneficiaries';
import { toast } from 'react-toastify';
import useUpload from '../../../hooks/useUpload';
import useBranchPermission from '../../../hooks/useBranchPermission';
import paths from 'routes/paths';

function EditOrphanage() {
  const schoolColumns = [
    {
      accessor: 'first_name',
      Header: 'Name',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { first_name } = rowData.row.original;
        return <>{first_name}</>;
      }
    },
    {
      accessor: 'DOB',
      Header: 'Age',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { DOB } = rowData.row.original;
        return <>{dayjs(DOB).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender'
    },
    {
      accessor: 'created_at',
      Header: 'Registration',
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return <>{dayjs(created_at).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'inspiration',
      Header: 'Aspiration'
    },
    {
      accessor: 'id_',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <TableRowAction
            onCLickDelete={() => removeStudent(id)}
            isNotEdit
            subject={permissionsKeyMap.facilities.children.orphanage}
          />
        );
      }
    }
  ];

  const { id } = useParams();
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();

  const [showStudentAddModal, setShowStudentAddModal] = useState(false);

  const { orphanage: orphanageData } = useOrphanage(id);
  const { orphanageOrphans } = useOrphanageOrphans(id);
  const { updateOrphanageAsync, isUpdating: isUpdateOrphanageLoading } = useUpdateOrphanage();
  const { createOrphanageOrphanAsync } = useCreateOrphanageOrphan();
  const { deleteOrphanageOrphanAsync } = useDeleteOrphanageOrphan();

  const submitStudent = async (value) => {
    try {
      await createOrphanageOrphanAsync({
        orphanage_id: id,
        orphan_id: value
      });
      setShowStudentAddModal(false);
    } catch (error) {
      console.error('Error adding orphanage orphan:', error);
    }
  };

  const submitAddOrphanage = async (data) => {
    try {
      if (data.document && typeof data.document !== 'string') {
        data.document = await upload(data.document);
      }

      await updateOrphanageAsync({
        id,
        data
      });
      navigate(paths.orphanages);
    } catch (error) {
      console.error('Error updating orphanage:', error);
    }
  };

  const removeStudent = async (orphanId) => {
    try {
      await deleteOrphanageOrphanAsync(orphanId);
    } catch (error) {
      console.error('Error deleting orphanage orphan:', error);
    }
  };

  return (
    <>
      <OrphanageForm
        onSubmit={submitAddOrphanage}
        loading={isUpdateOrphanageLoading || uploadLoading}
        initValues={orphanageData || {}}
      />
      <SelectStudentModal
        show={showStudentAddModal}
        onHide={() => setShowStudentAddModal(false)}
        onSubmit={submitStudent}
      />
      <Row className="mt-3">
        <Col md={12} xxl={12} className="h-md-100">
          <CustomAdvanceTable
            data={orphanageOrphans?.map(item => item.orphan) ?? []}
            columns={schoolColumns}
            title="Orphans"
            addButtonLabel="Add Orphan"
            addButtonIcon="user"
            onClickAddNew={() => {
              setShowStudentAddModal(true);
            }}
            addNew
            subject={permissionsKeyMap.facilities.children.orphanage}
            bulkActionsOptions
            handleBulkAction
            selection={true}
          />
        </Col>
      </Row>
    </>
  );
}

export default EditOrphanage;
